<template>
  <section class="lg:px-16 lg:pl:20 py-6 lg:py-12 px-4">
      <p class="text-sm text-grey mb-4 text-center">Find out more about us</p>
      <h1 class="text-navy text-4xl font-semibold lg:text-6xl lg:font-bold text-center lg:w-1/2 lg:mx-auto">Meet your paddies</h1>
      <p class="mt-4 text-current text-sm text-center lg:w-3/5 lg:mx-auto">Paddy is a slang for friend in Nigeria, and as your friend we’ve got your back. We work endlessly to give you the best product.</p>
  </section>
</template>

<script>
export default {

}
</script>

<style>

</style>